import { OktaAuth } from "@okta/okta-auth-js";
import { OktaAuthModule } from "@okta/okta-angular";
// Okta конфиг
const oktaAuth = new OktaAuth({
  clientId: environment.okta.clientId,
  issuer: environment.okta.issuer,
  redirectUri: environment.okta.redirectUri,
  postLogoutRedirectUri: environment.okta.postLogoutRedirectUri,
  scopes: environment.okta.scopes,
  pkce: environment.okta.pkce,
  restoreOriginalUri: async (_oktaAuth, originalUri) => {
    window.location.replace("/equipments-bp-showcase");
  },
});

import {
  APP_INITIALIZER,
  ErrorHandler,
  ApplicationConfig,
  importProvidersFrom,
} from "@angular/core";

import { APP_BASE_HREF } from "@angular/common";
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import { appRoutes } from "./app.routes";
import { HttpInterceptorService } from "@app/core/http";
import {
  GlobalErrorHandler,
  AppInsightsHttpInterceptor,
} from "@app/core/error-handling";
import {
  HARD_TRANSLATION_LANGS,
  HARD_TRANSLATION_SERVICE,
  HARD_USER,
} from "@hardcode-kz/ui";
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { provideNgxMask } from "ngx-mask";
import { LocalizationService } from "@app/core/localization";
import { BehaviorSubject } from "rxjs";
import { ICurrentUser } from "@models/user-management/user";
import { SettingsService } from "@app/core/http";
import { AppConfigService } from "@app/core/config";
import { AuthService } from "@app/core/auth";
import { ToastrModule } from "ngx-toastr";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { UIFormModule } from "@dmms/shared/ui-kit/components/forms/ui-form/ui-form.module";
import { GridModule } from "@features/grid/grid.module";
import { IAppConfig } from "@models/core/setting";
import { provideCalAngular } from "@cvx/cal-angular";
import { environment } from "../environments/environment";
import { OVERLAY_DEFAULT_CONFIG } from "@angular/cdk/overlay";
import { LangEnum } from "@models/interface-management/localization";

function httpLoaderFactory(httpClient: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(
    httpClient,
    `${environment.apiUrl}v1/localizations/list/`,
    "",
  );
}

function initializeApp(
  appConfigService: AppConfigService,
  settingsService: SettingsService,
  authService: AuthService,
  translate: TranslateService,
): () => Promise<IAppConfig | null> {
  return async () => {
    await authService.getTokens().catch(() => {});
    const lang = (localStorage.getItem("lang") as LangEnum) || LangEnum.RU;

    try {
      await translate.use(lang).toPromise();
    } catch (error) {
      try {
        await translate.use(LangEnum.RU).toPromise();
      } catch (fallbackError) {}
    }

    try {
      return await appConfigService.loadSettings(settingsService);
    } catch (error) {
      return null;
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(appRoutes),
    importProvidersFrom(
      ToastrModule.forRoot(),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      }),
      NgbModule,
      UIFormModule,
      GridModule,
      OktaAuthModule.forRoot({ oktaAuth }),
    ),
    provideCalAngular({
      autoSignIn: environment.cal.autoSignIn,
      popupForLogin: environment.cal.popupForLogin,
      cacheLocation: environment.cal.cacheLocation,
      instance: environment.cal.instance,
      tenantId: environment.cal.tenantId,
      clientId: environment.cal.clientId,
      redirectUri: environment.cal.redirectUri,
      oidcScopes: environment.cal.oidcScopes,
      graphScopes: environment.cal.graphScopes,
    }),
    {
      provide: APP_BASE_HREF,
      useValue: "/",
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfigService, SettingsService, AuthService, TranslateService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInsightsHttpInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    provideNgxMask(),
    {
      provide: HARD_TRANSLATION_LANGS,
      useValue: LocalizationService.getLangList(),
    },
    {
      provide: HARD_USER,
      useFactory: () => new BehaviorSubject<ICurrentUser | null>(null),
    },
    {
      provide: HARD_TRANSLATION_SERVICE,
      useFactory: (service: TranslateService) => {
        return service;
      },
      deps: [TranslateService],
    },
    // {
    //   provide: HARD_SHIFTS_TOKEN,
    //   useFactory: () => new BehaviorSubject<IShift[]>([]),
    // },
    {
      provide: OVERLAY_DEFAULT_CONFIG,
      useValue: {
        usePopover: false,
      },
    },
  ],
};
